import { useEffect, useState } from 'react';
import httpClient from '../../../../services/http';
import { APIUtils } from '../../../../utils/apiutils';

const useFetchTests = () => {
    const [tests, setTests] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const bootstrapApplication = async () => {
            setLoading(true);
            try {
                const res = await httpClient.get(APIUtils.getAdminAPIEndpoint('testlist')).then(res => res.data);
                if (res.status === 'success') {
                    setTests(res.data);
                }
            } catch (e) {
                console.log(e);
                setError(e);
            } finally {
                setLoading(false);
            }
        };
        bootstrapApplication();
    }, []);

    return { tests, loading, error };
};

export default useFetchTests;